const isS3SignedUrl = (url: string | undefined | null): boolean => {
  if (!url) return false;
  return url.includes('amazonaws.com') && url.includes('X-Amz-Signature');
};

export default isS3SignedUrl;
